<template>
    <PreOrders
        :loaded="loaded"
        :pre-orders="preOrders"
        :excluded-columns="excludedColumns"
    />
</template>
<script>
import { mapState, mapActions } from "vuex";
import vuexstore from "./_store";
import PreOrders from "./_components/PreOrders.vue";
import { store, getters, mutations } from "src/global-store.js";

export default {
    name: "PreOrdersModule",
    components: {
        PreOrders,
    },
    data() {
        return {
            loaded: false,
        };
    },
    computed: {
        me() {
            return store.me;
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
        ...mapState("$_preOrder", {
            preOrders: (state) => state.preOrders,
        }),
        excludedColumns() {
            if (this.isCustomer) return ["Customer"];
            if (this.isDesigner) return ["Designer"];
            return [];
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_preOrder", vuexstore);
    },
    destroyed() {
        this.$store.unregisterModule("$_preOrder");
    },
    async created() {
        mutations.setNavbarTitle("Pre-Orders");
        await this.fetchPreOrders();
        mutations.setNavbarSubtitle(this.me?.customer_name);
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_preOrder", ["fetchPreOrders"]),
    },
};
</script>
